module.exports = __webpack_public_path__ + "img/logowhite.2654a998.svg";